module.exports = __webpack_public_path__ + "assets/img/69e6-nf.svg";